import { TransicionSolicitud, EstadoCaso } from "../types";

/**
 * Todas las transiciones validas para solicitudes.
 * El flujo es ramificado despues de "resolucion".
 *
 * Flujo principal:
 * rol_listo → en_preparacion → confirmacion_presentacion → solicitud_administrativa → resolucion
 *
 * Post-resolucion (bifurcaciones):
 * - ganado → cobro_facturacion + tesoreria
 * - parcialmente_ganado → cobro_facturacion + tesoreria + reclamo
 * - perdido → reclamo (opcional)
 * - desistido (desde cualquier estado pre-resolucion)
 */
export const TRANSICIONES_SOLICITUD: TransicionSolicitud[] = [
  // Flujo principal lineal
  {
    desde: "rol_listo",
    hacia: "en_preparacion",
    label: "Iniciar Preparacion",
  },
  {
    desde: "en_preparacion",
    hacia: "confirmacion_presentacion",
    label: "Confirmar y Preparar Presentacion",
    requiereDocumento: ["Poder", "CIP", "Inscripcion Dominio"],
  },
  {
    desde: "confirmacion_presentacion",
    hacia: "solicitud_administrativa",
    label: "Presentar Solicitud",
  },
  {
    desde: "solicitud_administrativa",
    hacia: "resolucion",
    label: "En Espera de Resolucion",
  },

  // Post-resolucion: resultados
  {
    desde: "resolucion",
    hacia: "ganado",
    label: "Ganado",
    creaEntidad: ["cobro", "tesoreria"],
  },
  {
    desde: "resolucion",
    hacia: "parcialmente_ganado",
    label: "Parcialmente Ganado",
    creaEntidad: ["cobro", "tesoreria", "reclamo"],
  },
  {
    desde: "resolucion",
    hacia: "perdido",
    label: "Perdido",
  },

  // Desde perdido: crear reclamo
  {
    desde: "perdido",
    hacia: "reclamo",
    label: "Iniciar Reclamo",
    creaEntidad: ["reclamo"],
  },

  // Desistimiento desde cualquier estado pre-resolucion
  {
    desde: "rol_listo",
    hacia: "desistido",
    label: "Desistir",
  },
  {
    desde: "en_preparacion",
    hacia: "desistido",
    label: "Desistir",
  },
  {
    desde: "confirmacion_presentacion",
    hacia: "desistido",
    label: "Desistir",
  },
  {
    desde: "solicitud_administrativa",
    hacia: "desistido",
    label: "Desistir",
  },
  {
    desde: "resolucion",
    hacia: "desistido",
    label: "Desistir",
  },
];

/**
 * Obtiene las transiciones disponibles desde un estado dado.
 */
export function getTransicionesDisponibles(estadoActual: EstadoCaso): TransicionSolicitud[] {
  return TRANSICIONES_SOLICITUD.filter((t) => t.desde === estadoActual);
}

/**
 * Labels amigables para cada estado de solicitud.
 */
export const ESTADO_SOLICITUD_LABELS: Record<EstadoCaso, string> = {
  rol_listo: "ROL Listo",
  en_preparacion: "En Preparacion",
  confirmacion_presentacion: "Confirmacion y Presentacion",
  solicitud_administrativa: "Solicitud Administrativa",
  resolucion: "En Resolucion",
  ganado: "Ganado",
  parcialmente_ganado: "Parcialmente Ganado",
  perdido: "Perdido",
  cobro_facturacion: "Cobro / Facturacion",
  tesoreria: "Tesoreria",
  reclamo: "Reclamo",
  desistido: "Desistido",
};

/**
 * Orden visual de los estados en el flujo principal.
 */
export const FLUJO_PRINCIPAL: EstadoCaso[] = [
  "rol_listo",
  "en_preparacion",
  "confirmacion_presentacion",
  "solicitud_administrativa",
  "resolucion",
];

/**
 * Estados terminales (no tienen transiciones de salida en el flujo).
 */
export const ESTADOS_TERMINALES: EstadoCaso[] = [
  "ganado",
  "parcialmente_ganado",
  "perdido",
  "cobro_facturacion",
  "tesoreria",
  "reclamo",
  "desistido",
];
